document.addEventListener("alpine:init", () => {
  Alpine.data(
    "bundles",
    ({
      otpFirst,
      badgePattern,
      pricePattern,
      currencyDivider,
      displayCompareAtPrice,
      displaySubscriptionBadge,
      displayOTPBadge,
    }) => {
      return {
        products: [],
        flavors: [],
        currentFlavor: null,
        bundleForm: null,
        displayCompareAtPrice: displayCompareAtPrice == "true",
        displaySubscriptionBadge: displaySubscriptionBadge == "true",
        displayOTPBadge: displayOTPBadge == "true",
        badgePattern: badgePattern ?? "[amount]",
        pricePattern: pricePattern ?? "[amount]",
        currencyDivider: currencyDivider ?? 100,
        purchaseTypes: null,
        purchaseType: null,
        isSubscription: false,
        otpFirst: otpFirst || false,

        init() {
          this.bundleForm = this.$refs.bundleForm;
          this.products = JSON.parse(this.$refs.productsData.textContent);
          this.purchaseTypes = JSON.parse(this.$refs.purchaseTypes.textContent);
          this.prepareFlavorsData();

          this.changeSelectedPurchaseType(
            this.otpFirst ? "otp" : "subscription"
          );

          window.addEventListener("kilgour:buybox:request-state", () => {
            this.emitStickyState();
          });

          console.log(this.products);
        },

        formatBenefits(benefits) {
          if (!benefits) return "";

          let html = `<ul class="ctr-bundle__item-list">
            ${benefits
              .split("\n")
              .map((benefit) => {
                return `<li>${benefit
                  .replace(
                    "[icon-delivery]",
                    "<span class='ctr-icon m-delivery'></span>"
                  )
                  .replace(
                    "[icon-time]",
                    "<span class='ctr-icon m-time'></span>"
                  )}</li>`;
              })
              .join("")}
          </ul>`;

          return html;
        },

        prepareFlavorsData() {
          if (!this.products) return;
          this.flavors = [];

          this.products.forEach(
            ({
              product,
              metafields,
              custom_bundle_image: customBundleImage,
              custom_bundle_title: customBundleTitle,
              promotional_price: promotionalPrice,
              subscription_promotional_price: subscriptionPromotionalPrice,
              subscription_promo_label: subscriptionPromoLabel,
            }) => {
              let alternativeImage = customBundleImage || null;
              const firstVariant = product.variants[0];

              const flavorImage =
                alternativeImage ||
                firstVariant.featured_image ||
                product.featured_image;

              const variantPrice = Number(firstVariant.price || 0);
              const productCompareAt = Number(product.compare_at_price || 0);
              const variantCompareAt = Number(firstVariant.compare_at_price || 0);

              const oneTimeReferencePrice =
                productCompareAt && productCompareAt > variantPrice
                  ? productCompareAt
                  : variantCompareAt && variantCompareAt > variantPrice
                    ? variantCompareAt
                    : variantPrice;

              const subscriptionPrice =
                firstVariant.selling_plan_allocations[0].price;
              const subscriptionOldPrice = oneTimeReferencePrice;
              const parsedPromotionalPrice = Number(promotionalPrice);
              const parsedSubscriptionPromotionalPrice = Number(
                subscriptionPromotionalPrice
              );
              const promotionalPriceValue =
                Number.isFinite(parsedPromotionalPrice) &&
                parsedPromotionalPrice > 0
                  ? parsedPromotionalPrice
                  : null;
              const subscriptionPromotionalPriceValue =
                Number.isFinite(parsedSubscriptionPromotionalPrice) &&
                parsedSubscriptionPromotionalPrice > 0
                  ? parsedSubscriptionPromotionalPrice
                  : null;
              const effectiveOtpPrice =
                promotionalPriceValue || firstVariant.price;
              const effectiveSubscriptionPrice =
                subscriptionPromotionalPriceValue || subscriptionPrice;

              this.flavors.push({
                parentId: product.id,
                id: firstVariant.id,
                title: customBundleTitle || product.title,
                description: product.description,
                image: flavorImage,
                benefitsOtp: this.formatBenefits(
                  metafields.bundle_benefits_otp
                ),
                benefitsSubscription: this.formatBenefits(
                  metafields.bundle_benefits
                ),
                refillText: metafields.bundle_refill_text,
                link: {
                  handle: product.handle,
                  url: `/products/${product.handle}`,
                },
                prices: {
                  otp: {
                    currentPrice: firstVariant.price,
                    compareAtPrice:
                      oneTimeReferencePrice > variantPrice
                        ? oneTimeReferencePrice
                        : null,
                  },
                  subscription: {
                    currentPrice: subscriptionPrice,
                    oldPrice: subscriptionOldPrice,
                  },
                },
                savings: {
                  otp: oneTimeReferencePrice - effectiveOtpPrice,
                  subscription: oneTimeReferencePrice - effectiveSubscriptionPrice,
                },
                badge_text: (() => {
                  const otpPct = Math.round(
                    ((oneTimeReferencePrice - effectiveOtpPrice) /
                      oneTimeReferencePrice) *
                      100
                  );

                  const subPct = Math.round(
                    ((subscriptionOldPrice - effectiveSubscriptionPrice) /
                      subscriptionOldPrice) *
                      100
                  );

                  return {
                    otp:
                      otpPct > 0
                        ? `${badgePattern.replace("[percentage]", otpPct)}%`
                        : null,
                    subscription:
                      subPct > 0
                        ? `${badgePattern.replace("[percentage]", subPct)}%`
                        : null,
                  };
                })(),
                selling_plan: firstVariant.selling_plan_allocations[0],
                promotionalPrice: promotionalPriceValue,
                subscriptionPromotionalPrice: subscriptionPromotionalPriceValue,
                subscriptionPromoLabel: subscriptionPromoLabel || null,
              });
            }
          );

          this.currentFlavor = this.flavors[0];
        },

        emitStickyState() {
          try {
            const isSub = !!this.isSubscription;
            const price = isSub
              ? this.currentFlavor.subscriptionPromotionalPrice ??
                this.currentFlavor.prices.subscription.currentPrice
              : this.currentFlavor.promotionalPrice ??
                this.currentFlavor.prices.otp.currentPrice;

            const compareAt = isSub
              ? this.currentFlavor.prices.subscription.oldPrice
              : this.displayCompareAtPrice
                ? this.currentFlavor.prices.otp.compareAtPrice
                : null;

            const pct =
              compareAt && price
                ? Math.round(((compareAt - price) / compareAt) * 100)
                : null;

            const subtext =
              pct && pct > 0
                ? isSub
                  ? `Save ${pct}% with subscription`
                  : `Save ${pct}%`
                : isSub
                  ? "Subscribe & save"
                  : "";

            window.dispatchEvent(
              new CustomEvent("kilgour:buybox:change", {
                detail: {
                  title: this.currentFlavor.title,
                  variantId: String(this.currentFlavor.id),
                  sellingPlanId: isSub
                    ? String(this.currentFlavor.selling_plan.selling_plan_id)
                    : "",
                  img: this.currentFlavor.image || null,
                  formattedPrice: this.formatPrice(price),
                  formattedCompareAt: compareAt
                    ? this.formatPrice(compareAt)
                    : null,
                  subtext: subtext || null,
                },
              })
            );
          } catch (e) {}
        },

        updateForm() {
          const parentIdField = this.bundleForm.querySelector(
            'input[name="product-id"]'
          );
          const variantIdField =
            this.bundleForm.querySelector('input[name="id"]');
          const sellingPlanField = this.bundleForm.querySelector(
            'input[name="selling_plan"]'
          );

          parentIdField.value = this.currentFlavor.parentId;
          variantIdField.value = this.currentFlavor.id;
          sellingPlanField.value = this.isSubscription
            ? this.currentFlavor.selling_plan.selling_plan_id
            : "";

          this.emitStickyState();
        },

        changeSelectedFlavor(flavorId) {
          this.currentFlavor = this.flavors.find(
            (flavor) => flavor.id == flavorId
          );

          this.updateForm();
        },

        changeSelectedPurchaseType(purchaseTypeId) {
          this.purchaseType = this.purchaseTypes.find(
            (type) => type.id === purchaseTypeId
          );

          this.isSubscription = this.purchaseType?.id === "subscription";

          this.updateForm();
        },

        formatPrice(price) {
          if (price === null || price === undefined) return "";

          return this.pricePattern.replace(
            "[amount]",
            (price / this.currencyDivider).toFixed(2)
          );
        },
      };
    }
  );
});
